import AppFormInput from '../../../components/ui/AppFormInput';
import React, {useState, useRef, useEffect, useCallback} from 'react';
import {Link, useHistory} from 'react-router-dom';
import logo from '../../../assets/images/logo.png';
import apiClient from "../../../services/api-client";
import {Toast} from 'primereact/toast';
import PhoneInput from 'react-phone-input-2';
import {Skeleton} from 'primereact/skeleton';
import {useAuth} from '../components/use-auth';
// import '../../../assets/styles/auth-tokens.css';
// import '../../../assets/styles/landing.css';
// import '../../../assets/styles/auth-form.css';


const RegisterPolicyholder = () => {
    const toast = useRef(null);
    const history = useHistory();
    const {logout} = useAuth();

    const [step, setStep] = useState(1);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    // Unified input for either Policy Number or National ID
    const [searchQuery, setSearchQuery] = useState('');

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [policyNumber, setPolicyNumber] = useState('');
    const [nationalId, setNationalId] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');

    useEffect(() => {
        logout();
    }, [logout]);

    const stepCopy = {
        1: {
            title: 'Link your existing policy',
            subtitle: 'Enter your policy number or National ID to find your policy.'
        },
        2: {
            title: 'Set up your portal login',
            subtitle: 'Complete your registration by setting up your contact details.'
        }
    }[step];

    const showError = useCallback((detail, summary = 'Something went wrong') => {
        toast.current?.show({severity: 'error', summary, detail, life: 5000});
    }, []);

    const apiError = useCallback((err, fallback) => {
        showError(err?.response?.data?.message || fallback);
    }, [showError]);

    const verifyPolicy = () => {
        const e = {};
        if (!searchQuery.trim()) e.searchQuery = 'Please enter a Policy number or National ID';
        setErrors(e);
        if (Object.keys(e).length) return;

        setLoading(true);

        apiClient
            .get('user/verify-policy', {
                params: { identifier: searchQuery.trim() }
            })
            .then((res) => {
                setLoading(false);
                if (res.data.status !== 'SUCCESS') return showError(res.data.message, 'Not found');
                const v = res.data.responseBody;
                
                setFirstName(v.firstName || '');
                setLastName(v.lastName || '');
                setNationalId(v.idNumber || (searchQuery.match(/^\d/) ? searchQuery.trim() : ''));
                setPolicyNumber(v.policyNumber || (!searchQuery.match(/^\d/) ? searchQuery.trim() : ''));
                setEmailAddress(v.emailAddress || '');
                setStep(2);
            })
            .catch((err) => {
                console.error('Error verifying policy:', err);
                setLoading(false);
                apiError(err, 'We could not verify that policy. Please check your details.');
            });
    };

    const startRegistration = () => {
        const e = {};
        if (!nationalId.trim()) e.nationalId = 'National ID is required';
        if (!/\S+@\S+\.\S+/.test(emailAddress)) e.emailAddress = 'Enter a valid email address';
        if (!phoneNumber.trim()) e.phoneNumber = 'Mobile number is required';
        
        setErrors(e);
        if (Object.keys(e).length) return;

        setLoading(true);
        apiClient
            .post('user/policyholder/register', {
                policyNumber: policyNumber.trim(),
                nationalId: nationalId.trim(),
                emailAddress: emailAddress.trim(),
                phoneNumber: phoneNumber.trim(),
            })
            .then((res) => {
                setLoading(false);
                if (res.data.status !== 'SUCCESS') return showError(res.data.message);
                
                // Redirect directly to reset password page for user to verify OTP and set a password
                // Since the router requires an :otp parameter, we pass a space as a placeholder 
                // so the route matches correctly without pre-filling confusing text in the input.
                history.replace(`/set-password/${res.data.responseBody.userId}/ `);
            })
            .catch((err) => {
                setLoading(false);
                apiError(err, 'We could not start your registration. Please try again.');
            });
    };

    return (
        <>
            <Toast ref={toast}/>
            <div className="min-h-screen bg-[#F8FAFC] flex flex-col justify-center py-12 sm:px-6 lg:px-8">
                <div className="sm:mx-auto sm:w-full sm:max-w-md">
                    <div className="text-center mb-8 flex flex-col items-center">
                        <Link to="/landing" className="flex items-center justify-center space-x-3 mb-6"><img className="h-10 w-auto" src={logo} alt="Doves" /><span className="bg-[#EBF5FF] text-[#135A9C] font-black text-[10px] px-3 py-1 rounded-full uppercase tracking-widest">Life Assurance Self-Service Portal</span></Link>
                        
                        <h1 className="text-2xl font-extrabold text-slate-800 mt-2 tracking-tight">{stepCopy.title}</h1>
                        <p className="mt-2 text-sm text-slate-500">{stepCopy.subtitle}</p>
                    </div>

                    <div className="bg-white py-8 px-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] sm:rounded-3xl sm:px-10 border border-slate-100">
                        {loading ? (
                            <>
                                <Skeleton width="100%" height="46px" className="mb-3"/>
                                <Skeleton width="100%" height="46px" className="mb-3"/>
                                <Skeleton width="100%" height="44px"/>
                            </>
                        ) : (
                            <>
                                {step === 1 && (
                                    <form onSubmit={(e) => {
                                        e.preventDefault();
                                        verifyPolicy();
                                    }}>
                                        <AppFormInput
  label="Policy Number or National ID"
  placeholder="e.g. POL123456 or 63-1234567A00"
  value={searchQuery}
  onChange={(e) => setSearchQuery(e.target.value)} error={errors.searchQuery }
/>
                                        <button type="submit" className="btn w-full rounded-full font-bold mt-6 bg-[#135A9C] hover:bg-[#0f4b82] text-white border-none">Verify
                                            Policy
                                        </button>
                                    </form>
                                )}

                                {step === 2 && (
                                    <form onSubmit={(e) => {
                                        e.preventDefault();
                                        startRegistration();
                                    }}>
                                        <p className="text-slate-500 text-xs mt-1" style={{marginBottom: '1rem'}}>
                                            Welcome, <strong>{firstName} {lastName}</strong>
                                        </p>

                                        <AppFormInput
  label="National ID"
  type="text"
  autoComplete="off"
  value={nationalId}
  onChange={(e) => setNationalId(e.target.value)} error={errors.nationalId }
/>
                                        <AppFormInput
  label="Policy Number"
  value={policyNumber}
  readOnly
  disabled
  inputClassName="bg-slate-50 border-slate-200 text-slate-500"
  style={{backgroundColor: '#f3f4f6', cursor: 'not-allowed'}}
/>

                                        <AppFormInput
  label="Email address"
  placeholder="you@example.com"
  value={emailAddress}
  onChange={(e) => setEmailAddress(e.target.value)} error={errors.emailAddress }
/>
                                        <div className="form-control w-full space-y-1 mb-4">
                                            <label className="label-text text-xs font-bold text-slate-700">Mobile number</label>
                                            <PhoneInput country={'zw'} international={false} value={phoneNumber}
                                                        inputStyle={{width: '100%', height: '43px'}}
                                                        onChange={(v) => setPhoneNumber(v)}/>
                                            <p className="text-slate-500 text-xs mt-1">Must match the number Doves has on record. The code is sent there.</p>
                                            {errors.phoneNumber && <p className="text-error text-xs mt-1">{errors.phoneNumber}</p>}
                                        </div>

                                        <button type="submit" className="btn w-full rounded-full font-bold mt-6 bg-[#135A9C] hover:bg-[#0f4b82] text-white border-none">Send
                                            verification code
                                        </button>
                                    </form>
                                )}

                                <p className="mt-8 pt-4 border-t border-slate-100 text-center text-xs text-slate-500">
                                    Already have an account? <Link className="font-bold text-[#135A9C] hover:underline ml-1" to="/signin">Sign in</Link>
                                </p>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default RegisterPolicyholder;
